<template>
    <div class="right-panel">
        <div class="card">
            <div class="card-header" @click="ritorno=!ritorno">
                <h3 class="mb-2">{{title}}</h3>
                <slot name="header"></slot>
            </div>
            <div class="card-body">
                <slot></slot>
            </div>
            <div v-if="$slots.footer" class="card-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'RightPanel',
  props: {
    title: String
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/templates/RightPanel.vue